import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import { translateAndSortAscendant } from "../../../../common/helper";

export default function Nationality() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [nationalities, setNationalities] = useState([]);

  useEffect(() => {
    CommonService.getAllNationalities().then((data) => setNationalities(translateAndSortAscendant (data, "description")));
  }, []);
  
  return (
    <fieldset>
      <legend>{t("Nationality")}</legend>
      <select
        name="nationalityId"
        onChange={onChange}
        value={searchObject.nationalityId || ""}
        className="form-select"
      >
        <option value=""></option>
        {nationalities.map((nationality) => (
          <option key={nationality.id} value={nationality.id}>
            {t(nationality.description)}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
